import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      mirrors: {
        mirrors_list_js: {
          add_tracking: {
            save: 'JS_SAVE',
            back: 'JS_BACK',
            tabs: {
              manual: {
                form: {
                  link: 'JS_MANUAL_LINK',
                  priority: 'JS_MANUAL_PRIORITY',
                  enabled: 'JS_MANUAL_ENABLED',
                },
              },
            },
          },
        },
        mirrors_list_no_js: {
          add_tracking: {
            save: 'NO_JS_SAVE',
            back: 'NO_JS_BACK',
            tabs: {
              manual: {
                form: {
                  link: 'NO_JS_MANUAL_LINK',
                  priority: 'NO_JS_MANUAL_PRIORITY',
                  enabled: 'NO_JS_MANUAL_ENABLED',
                },
              },
            },
          },
        },
      },
    },
  }));
}
